import WithProposalContainer from '../Common/WithProposalContainer'
import QueryPage from '../../components/BatchProposal/QueryPage'
import WithS3Service from '../Common/WithS3Service'

QueryPage.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const props = {}

const MappedContainer = WithProposalContainer(WithS3Service(QueryPage), props)

export default MappedContainer
